<template>
    <button
        type="button"
        class="inline-flex items-start gap-1 p-0"
    >
        <span class="text-sm font-light underline underline-offset-3">{{ $t('general.close') }}</span>
        <span
            class="inline-flex size-4 items-center justify-center rounded-full border border-solid border-current p-1"
        >
            <svg
                viewBox="-0.1 -0.1 6 6"
                xmlns="http://www.w3.org/2000/svg"
                height="6"
                width="6"
            >
                <path
                    d="m0.18125 5.618508333333333 5.4375 -5.4375"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                ></path>
                <path
                    d="M5.61875 5.618508333333333 0.18125 0.18100833333333333"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                ></path>
            </svg>
        </span>
    </button>
</template>
